exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-area[data-v-354ac27c]{width:100%;margin-right:0;padding:0 20px;margin-top:30px}.content-area h2[data-v-354ac27c]{font-family:ClanPro;color:#008bd0;font-size:20px;margin-bottom:30px;position:relative;padding-bottom:5px;border-bottom:1px solid #008bd0}.content-area label[data-v-354ac27c]{font-size:12px}.content-area .change-password__btn[data-v-354ac27c]{width:100%;display:flex;flex-wrap:wrap;flex-direction:row;align-items:center;text-align:center;justify-content:space-between;height:50px;color:#fff;background-color:#becd00;margin-top:40px;border-radius:0;outline:none}.content-area .change-password__btn img[data-v-354ac27c]{width:25px;margin-left:5px}.content-area .change-password__btn span[data-v-354ac27c]{font-size:12px;font-family:ClanPro}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-354ac27c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/User/UserAddIndispo.vue
// module id = 530
// module chunks = 0